import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createRoot } from "react-dom/client";
import { ApolloProvider } from "@apollo/client";
import App from "./app/app/App";
import { client } from "./core/apollo/client";
import "assets/styles/main.scss";
import { BrowserRouter } from "react-router-dom";
import { Box, CssBaseline, ThemeProvider } from "@mui/material";
import { themeOptions } from "./theme";
import CapitalThemeLoader from "app/app/CapitalThemeLoader";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/en-au";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import relativeTime from "dayjs/plugin/relativeTime";
import duration from "dayjs/plugin/duration";
if (process.env.NODE_ENV !== "production") {
    localStorage.setItem("debug", "capital:*");
}
dayjs.locale("en-au");
dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);
dayjs.extend(duration);
createRoot(document.getElementById("root")).render(_jsx(ApolloProvider, { client: client, children: _jsx(ThemeProvider, { theme: themeOptions, children: _jsx(BrowserRouter, { children: _jsx(CapitalThemeLoader, { children: _jsx(LocalizationProvider, { dateAdapter: AdapterDayjs, adapterLocale: "en-au", children: _jsxs(Box, { sx: { display: "flex" }, children: [_jsx(CssBaseline, {}), _jsx(App, {})] }) }) }) }) }) }));
